module.exports = __webpack_public_path__ + "img/number.a24a6656.svg";